module.exports = __webpack_public_path__ + "static/media/6_School of the animals_AF.4c1ba24c.txt";